import { render, staticRenderFns } from "./WebHead.vue?vue&type=template&id=4976bab2&scoped=true"
import script from "./WebHead.vue?vue&type=script&lang=js"
export * from "./WebHead.vue?vue&type=script&lang=js"
import style0 from "./WebHead.vue?vue&type=style&index=0&id=4976bab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4976bab2",
  null
  
)

export default component.exports